<style>
  .handsontable table thead th {
  white-space: pre-line;
}

.handsontable .relative {
position: relative;
text-align: left;
}

.hidden {
display: none;
}

/* Keep the frozen left column lined up with the body by only letting the master pane
   show its scrollbars on hover. This component is ViewEncapsulation.None, so these
   selectors go into the document unscoped - they must stay anchored to .event-anchor,
   or they switch off the scrollbars of every other Handsontable sheet in the app. */
.event-anchor .ht_master .wtHolder {
overflow: hidden;
}

.event-anchor:hover .ht_master .wtHolder {
overflow: auto;
}
</style>

<div style="position:relative;height:100%;">
  <div #utils_bar class="row hideonprint utils-bar" style="background:#f5f5f5;">
    <div class="row justify-start table-filter" >
      <utils-bar [search]="true"
        (searchValueSubmitted)="filter_string=$event;updateSearchFilter()"
        (searchCleared)="filter_string='';updateSearchFilter();"
        >
      </utils-bar>
      <button mat-flat-button class="search-button" matTooltip="Insert new row" (click)="insert()">
        <i class="fa fa-plus"></i>
      </button>
      @if (filter_warning) {
        <div class="row hideonprint warning info" style="padding: 4px;">
          {{filter_warning}}
        </div>
      }
    </div>
    <mat-paginator [pageSizeOptions]="page_size_options.concat(events_total)"
      showFirstLastButtons
      style="justify-self: flex-end;">
    </mat-paginator>
  </div>

  <div #scroll_area class="scroll-area" overlay-scrollbars [defer] [options]="{scrollbars: {autoHide: 'leave'}}"
    style="position:relative;">
    @if (hot) {
      <div #event_anchor id="{{hot.handson_id}}" class="event-anchor"></div>
    }
  </div>

  @if (!config.event_types?.length) {
    <h4>
      Please select an event type.
    </h4>
  }

  <div [ngStyle]="{'display': saving? 'flex' : 'none'}" class="app-loading">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</div>
